export default __webpack_public_path__ + "static/media/cloth.aa64ec8f.PNG";